import React, { type ReactNode, useContext, useRef } from "react";
import { useStore } from "zustand";

import { createImageEditorStore } from "./store";
import type { AllStoreType } from "./store/imageEditor.type";

export type ImageStoreProviderProps = {
  children: ReactNode;
};

export type ImageEditorStoreApi = ReturnType<typeof createImageEditorStore>;

const ImageEditorStoreContext = React.createContext<
  undefined | ImageEditorStoreApi
>(undefined);

export const ImageStoreProvider = ({ children }: ImageStoreProviderProps) => {
  const storeRef = useRef<ImageEditorStoreApi>();
  if (!storeRef.current) {
    storeRef.current = createImageEditorStore();
  }

  return (
    <ImageEditorStoreContext.Provider value={storeRef.current}>
      {children}
    </ImageEditorStoreContext.Provider>
  );
};

export const useImageEditorStore = <T,>(
  selector: (store: AllStoreType) => T
): T => {
  const imageEditorStoreContext = useContext(ImageEditorStoreContext);

  if (!imageEditorStoreContext) {
    throw new Error("useCounterStore must be used within CounterStoreProvider");
  }

  return useStore(imageEditorStoreContext, selector);
};
